import { render, staticRenderFns } from "./pubTel.vue?vue&type=template&id=3a2b1384&scoped=true&"
import script from "./pubTel.vue?vue&type=script&lang=js&"
export * from "./pubTel.vue?vue&type=script&lang=js&"
import style0 from "./pubTel.vue?vue&type=style&index=0&id=3a2b1384&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a2b1384",
  null
  
)

export default component.exports